const language = {
    namespaced: true,
    state: {
        langs:{}
    },
    mutations: {
        set_lang(state, val){
            state.langs = val
        }    
    },
    getters: {
        get_lang: (state) => (val) => {
            return state.langs[val.trim()] ? state.langs[val.trim()] : val.trim()
        }
    }
}

export default language


// WEBPACK FOOTER //
// ./src/vuex/modules/language.js